import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants.js";

export const NewLifeAccountButtonStyled = styled.div`
    flex: 1 0 50%;
    text-align: left;

    padding: 16px;
    cursor: default;
    border: 1px solid transparent;
    font-weight: 700;
    font-size: 18px;
    color: var(--color-secondary);
    border-radius: 16px;
    background: #373858;
    transition: all 500ms;
    margin: 0 8px 12px;

    svg {
        width: 48px;
        height: 48px;
        fill: var(--color-secondary-active);
        margin-right: 12px;

        background: rgba(125, 134, 178, 0.1);
        border-radius: 8px;
        padding: 8px;
        transition: all 500ms;
    }

    &:hover,
    &.active {
        color: var(--color-white);

        svg {
            fill: var(--color-yellow);
            background: rgba(255, 221, 60, 0.2);
        }
    }

    &.active {
        border-color: var(--color-yellow);
    }

    &.respawned {

        &:hover,
        &.active {
            border: 1px solid #7D86B2;

            svg {
                fill: var(--icon-primary-color);
                background: rgba(125, 134, 178, 0.2);
            }

            .refilled {
                opacity: 1;
            }
        }
    }

    .refilled {
        background: rgba(20, 198, 121, 0.2);
        border-radius: 4px;
        color: #54EEAB;
        float: right;
        font-size: 14px;
        font-weight: 600;
        margin: 10px 0;
        opacity: 0.5;
        padding: 2px 6px;
        transition: all 500ms;
    }
`;

export const NewLifeRespawnModalStyled = styled.div`
    padding: 0 24px 24px;
`;

export const NewLifeCurrentEquityStyled = styled.div`
    margin-bottom: 24px;

    color: var(--color-secondary);

    span {
        color: var(--color-white);
        font-weight: 600;
    }
    
    @media (max-width: ${BREAKPOINTS.medium}px) {
        margin-bottom: 16px;
    }
`;

export const NewLifeRefundAmountInfoStyled = styled.div`
    max-width: 300px;

    @media (max-width: ${BREAKPOINTS.small}px) {
        max-width: unset;
    }
`;

export const NewLifeRefundDepositInfoStyled = styled.div`
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 8px;
    background-color: var(--color-surface);
    border-radius: 8px;
`;

export const NewLifeRefundAmountStyled = styled.div`
    margin-bottom: 24px;
    padding: 16px 70px;
    background: #373858;

    border: 1px solid var(--color-surface);
    border-radius: 16px;
    position: relative;
    display: inline-block;

    > p {
        color: var(--color-secondary);
        margin-bottom: 8px;
    }

    > div {
        color: var(--color-white);
        font-weight: 700;
        font-size: 36px;
    }

    > span {
        position: absolute;
        top: 12px;
        right: 12px;
        display: block;
    }

    @media (max-width: ${BREAKPOINTS.medium}px) {
        display: block;
        margin-left: 16px;
        margin-right: 16px;
        margin-bottom: 16px;
        
        > p {
            font-size: 14px;
        }

        > div {
            font-weight: 600;
            font-size: 24px;
        }
    }
`;
export const NewLifeNoPositionsStyled = styled.div`
    margin-bottom: 24px;
    padding: 16px;

    border: 1px solid var(--color-surface);
    border-radius: 16px;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        border-right: none;
        border-left: none;
        border-radius: 0;
        margin-bottom: 16px;
    }
`;
export const NewLifePositionsStyled = styled.div`
    margin-bottom: 24px;

    @media (max-width: ${BREAKPOINTS.medium}px) {
        margin-bottom: 16px;
    }
    
    .accordion {
        border: 1px solid var(--color-surface);

        @media (max-width: ${BREAKPOINTS.medium}px) {
            border-right: none;
            border-left: none;
            border-radius: 0;
        }
    }

    .accordion-body {
        padding: 0 0 8px;
    }

    .accordion-item {
        @media (max-width: ${BREAKPOINTS.medium}px) {
            border-radius: 0;
        }

        &:last-of-type .accordion-collapse {
            border-radius: 0;
        }
    }

    .accordion-button {
        font-weight: 400;
        font-size: 16px;

        @media (max-width: ${BREAKPOINTS.medium}px) {
            font-size: 14px;
            padding: 16px;
            .badge {
                display: none;
            }
        }

    }

    .flex-row {
        width: 100%;
    }

    .position-header {
        background-color: var(--color-surface);
        text-align: left;
        padding: 8px 24px;
        @media (max-width: ${BREAKPOINTS.medium}px) {
            padding: 8px 16px;
        }
    }

    .position-row {
        padding: 16px 24px;
        @media (max-width: ${BREAKPOINTS.medium}px) {
            padding: 8px 16px;
        }
    }

    .symbol {
        font-weight: 600;
        font-size: 14px;
    }

    .side {
        font-weight: 600;
        font-size: 14px;
        margin-left: 8px;
    }

    .pl-title {
        color: var(--color-secondary);
    }

    .pl {
        font-weight: 600;
        font-size: 14px;
        padding-left: 8px;
    }
`;

export const NewLifeBlockStyled = styled.div`
    @media (max-width: ${BREAKPOINTS.medium}px) {
        padding-left: 16px;
        padding-right: 16px;
    }
`;
